import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/StoreGrid.css';
import amazon from '../assets/amazon.png';
import myntra from '../assets/myntra.png';
import flipkart from '../assets/flipkart.png';
import ajio from '../assets/ajio.png';
import bookmyshow from '../assets/bookmyshow.png';

const stores = [
  {
    name: 'Myntra Mega March Sale',
    code: 'MYNTRA350',
    logo: myntra,
    title: 'Myntra Mega March Sale 2026 – Flat 80% OFF + Extra ₹350 Discount on Fashion & Lifestyle.',
  },
  {
    name: 'Nike Footwear Fest on Flipkart',
    code: 'FLIP75',
    logo: flipkart,
    title: 'Nike Footwear Fest – Flat 60% to 75% OFF on Men’s Shoes | Exclusive Flipkart Deals | March 2026.',
  },
  {
    name: 'BookMyShow Movie Carnival',
    code: 'BMSFUN150',
    logo: bookmyshow,
    title: 'BookMyShow Movie Carnival – Buy 1 Get 1 FREE on Movie Tickets + Up to ₹150 Cashback via Pay Wallets | Valid till March 2026.',
  },
  {
    name: 'AJIO Big Fashion Days',
    code: 'AJIO500',
    logo: ajio,
    title: 'AJIO Big Fashion Days 2026 – Up to 90% OFF + Extra ₹500 Off on ₹2499+ Orders | March Limited Offer.',
  },
  {
    name: 'Amazon March Savings Bonanza',
    code: 'CLIPMARCH2026',
    logo: amazon,
    title: 'Amazon March Savings Bonanza – Collect “Clip” Coupons to Get Extra 10–20% OFF on Electronics, Home & Essentials. Discounts Auto‑Applied at Checkout.',
  },
];

const StoreGrid = () => {
  const [startIndex, setStartIndex] = useState(0);
  const itemsPerPage = 4;
  const navigate = useNavigate();

  const nextSlide = () => {
    setStartIndex((prev) => (prev + 1) % stores.length);
  };

  const prevSlide = () => {
    setStartIndex((prev) => (prev - 1 + stores.length) % stores.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const visibleStores = Array.from({ length: itemsPerPage }, (_, i) => {
    const index = (startIndex + i) % stores.length;
    return stores[index];
  });

  const handleCardClick = (code) => {
    navigate(`/coupon/${code}`);
  };

  return (
    <div className="carousel-wrapper">
      <button className="nav-button left" onClick={prevSlide}>&#8592;</button>
      <div className="store-grid-carousel">
        {visibleStores.map((store, idx) => (
          <div
            key={idx}
            className="store-card"
            onClick={() => handleCardClick(store.code)}
            style={{ cursor: 'pointer' }}
          >
            <img src={store.logo} alt={store.name} />
            <p className="storep">{store.name}</p>
            <p className="storetitle">{store.title}</p>
          </div>
        ))}
      </div>
      <button className="nav-button right" onClick={nextSlide}>&#8594;</button>
    </div>
  );
};

export default StoreGrid;
